import React from 'react';
import { createMergingContextProvider } from '@wix/da-react-context/pkg/helpers';

export interface CommentFeaturesContextProps {
  showLikeButton?: boolean;
  showAwardBadgeButton?: boolean;
}

export const propsDefaults: CommentFeaturesContextProps = {
  showLikeButton: true,
  showAwardBadgeButton: true,
};

export const CommentFeaturesContext =
  React.createContext<CommentFeaturesContextProps>(propsDefaults);
CommentFeaturesContext.displayName = 'CommentFeaturesContext';

export const CommentFeaturesContextProvider = createMergingContextProvider(CommentFeaturesContext);
